import Link from "shared/components/navigation/links/Link";
import styled from "styled-components";

export const Icon = styled.div`
    height: fit-content;
`;

export const Content = styled.div`
    padding-top: 0.5rem;
    font-size: ${globalThis.config.fonts.sizes.medium};
    font-family: ${globalThis.config.fonts.families.light};
    height: fit-content;
`;

export const ErrorDetail = styled.div`
    color: ${globalThis.config.colors.grey2};
    font-size: ${globalThis.config.fonts.sizes.small};
    height: fit-content;
    padding-bottom: 1rem;
    p {
        margin: 0;
    }
`;

export const Header = styled.div`
    padding-top: 0.5rem;
    font-size: ${globalThis.config.fonts.sizes.xlarge};
    font-family: ${globalThis.config.fonts.families.medium};
    height: fit-content;
`;

export const Body = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const Footer = styled.div`
    padding-top: 0.5rem;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: auto;
`;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    text-align: left;
    padding: 0.5rem 4rem 4rem 4rem;
    position: relative;

    min-width: ${(props) => (props.popup ? "28.25rem" : "inherit")};
    width: ${(props) => (props.popup ? "28.25rem" : "inherit")};
    max-width: ${(props) => (props.popup ? "28.25rem" : "inherit")};

    min-height: ${(props) => (props.popup ? "35.25rem" : "inherit")};
    height: ${(props) => (props.popup ? "35.25rem" : "inherit")};
    max-height: ${(props) => (props.popup ? "35.25rem" : "inherit")};

    text-align: ${(props) => (props.popup ? "center" : "left")};

    ${Header} {
        text-align: ${(props) => (props.popup ? "center" : "left")};
    }
    ${Body} {
        text-align: ${(props) => (props.popup ? "center" : "left")};
    }
    ${Footer} {
        text-align: ${(props) => (props.popup ? "left" : "center")};
        justify-content: ${(props) => (props.popup ? "flex-end" : "center")};
    }
`;

export const ReloadButton = styled(Link)`
    width: 81px;
    background: transparent;
    color: ${globalThis.config.colors.black};
    font-size: ${globalThis.config.fonts.sizes.smedium};
    margin-right: 32px;
    order: -1;
`;

export const ShowDetailsButton = styled.button`
    background: transparent;
    border: none;
    color: ${globalThis.config.colors.orange1};
    font-size: ${globalThis.config.fonts.sizes.small};
    cursor: pointer;
    padding: 0.5rem 0;
    text-decoration: underline;
    &:hover {
        color: ${globalThis.config.colors.orange2};
    }
`;

export const RawErrorContainer = styled.div`
    background-color: ${globalThis.config.colors.grey4};
    padding: 1rem;
    border-radius: 4px;
    margin: 0.5rem 0;
    max-height: 200px;
    overflow: auto;
    font-family: monospace;
    font-size: ${globalThis.config.fonts.sizes.small};
    text-align: left;
    white-space: pre-wrap;
    word-break: break-word;
`;

export const EmailSupportButton = styled.button`
    width: 11.75rem;
`;

export const TestConnectionButton = styled.button`
    width: 11.75rem;
`;
